var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chartse"},[_c('div',{staticClass:"row"},[_c('div',{staticStyle:{"width":"100%","max-width":"1000px","height":"650px"},attrs:{"id":_vm.myid}})])])}
var staticRenderFns = []

export { render, staticRenderFns }